/*
  Lie les epingles posees sur l'image aux points de qualite listes a cote.
  Le HTML est complet sans script : ici on n'ajoute que la mise en avant
  reciproque et la navigation clavier.
*/

class FabricDetail extends HTMLElement {
  connectedCallback() {
    this.pins = Array.from(this.querySelectorAll('[data-fabric-pin]'));
    this.points = Array.from(this.querySelectorAll('[data-fabric-point]'));

    if (!this.pins.length || !this.points.length) return;

    this.classList.add('fabric--interactive');

    this.pins.forEach((pin) => {
      const id = pin.dataset.fabricPin;
      pin.addEventListener('click', (event) => {
        // Le lien reste fonctionnel sans script ; ici on gere le defilement nous-memes
        // pour respecter la preference d'animation reduite.
        event.preventDefault();
        this.select(id, true);
      });
      pin.addEventListener('mouseenter', () => this.highlight(id));
      pin.addEventListener('mouseleave', () => this.highlight(null));
      pin.addEventListener('focus', () => this.highlight(id));
      pin.addEventListener('blur', () => this.highlight(null));
    });

    this.points.forEach((point) => {
      const id = point.dataset.fabricPoint;
      point.addEventListener('mouseenter', () => this.highlight(id));
      point.addEventListener('mouseleave', () => this.highlight(null));
    });

    /*
      Sur grand ecran la liste est longue : on met en avant le point le plus
      proche du centre du viewport pour que l'epingle correspondante suive.
    */
    if (window.matchMedia('(min-width: 990px)').matches && 'IntersectionObserver' in window) {
      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) this.select(entry.target.dataset.fabricPoint, false);
          });
        },
        { rootMargin: '-45% 0px -45% 0px' }
      );
      this.points.forEach((point) => this.observer.observe(point));
    }

    this.select(this.points[0].dataset.fabricPoint, false);
  }

  disconnectedCallback() {
    if (this.observer) this.observer.disconnect();
  }

  select(id, shouldScroll) {
    this.activeId = id;

    this.pins.forEach((pin) => {
      pin.classList.toggle('is-active', pin.dataset.fabricPin === id);
    });

    this.points.forEach((point) => {
      point.classList.toggle('is-active', point.dataset.fabricPoint === id);
    });

    if (!shouldScroll) return;

    const target = this.points.find((point) => point.dataset.fabricPoint === id);
    if (!target) return;

    const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
    target.scrollIntoView({ behavior, block: 'center' });
  }

  highlight(id) {
    const effective = id || this.activeId;
    this.pins.forEach((pin) => {
      pin.classList.toggle('is-hovered', pin.dataset.fabricPin === effective);
    });
    this.points.forEach((point) => {
      point.classList.toggle('is-hovered', point.dataset.fabricPoint === effective);
    });
  }
}

if (!customElements.get('fabric-detail')) {
  customElements.define('fabric-detail', FabricDetail);
}
